import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "../ui/button";
import { CLINIC, telLink, waLink } from "../../lib/clinic";

const NAV = [
  { id: "servicios", label: "Servicios" },
  { id: "doctor", label: "Sobre el Dr." },
  { id: "areas", label: "Áreas de atención" },
  { id: "testimonios", label: "Testimonios" },
  { id: "ubicacion", label: "Ubicación" },
  { id: "faq", label: "Preguntas" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-[hsl(var(--cream))]/85 backdrop-blur-xl border-b border-[hsl(var(--border))]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-3 group min-w-0" data-testid="navbar-logo">
          <span className="relative shrink-0 grid place-items-center w-10 h-10 md:w-11 md:h-11 rounded-full bg-[hsl(var(--navy))] overflow-hidden">
            <img
              src={CLINIC.logoUrl}
              alt="Cardiología Avanzada"
              className="w-full h-full object-cover"
              loading="eager"
            />
          </span>
          <div className="leading-tight min-w-0 max-w-[260px] sm:max-w-[320px] md:max-w-none">
            <div className="font-serif-display text-[13px] md:text-[15px] font-semibold text-[hsl(var(--navy))] truncate">
              {CLINIC.doctorName}
            </div>
            <div className="text-[9px] md:text-[10px] uppercase tracking-[0.14em] text-[hsl(var(--navy-soft))] truncate md:whitespace-normal md:line-clamp-2">
              Cardiología · Cuidados Coronarios · Ecocardiografía · ECMO
            </div>
          </div>
        </a>

        <nav className="hidden xl:flex items-center gap-7 shrink-0">
          {NAV.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              data-testid={`nav-link-${item.id}`}
              className="text-sm text-[hsl(var(--navy-soft))] hover:text-[hsl(var(--navy))] transition-colors underline-draw"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2 shrink-0">
          <a href={telLink} data-testid="navbar-call-link">
            <Button
              variant="outline"
              size="sm"
              className="rounded-full border-[hsl(var(--navy))] text-[hsl(var(--navy))] hover:bg-[hsl(var(--navy))] hover:text-[hsl(var(--cream))]"
            >
              <Phone className="w-4 h-4" /> Llamar
            </Button>
          </a>
          <a href={waLink()} target="_blank" rel="noreferrer" data-testid="navbar-wa-link">
            <Button
              size="sm"
              className="rounded-full bg-[hsl(var(--soft-red))] hover:bg-[hsl(var(--soft-red))]/90 text-white"
            >
              Agendar cita
            </Button>
          </a>
        </div>

        <button
          className="xl:hidden p-2 -mr-2 text-[hsl(var(--navy))] shrink-0"
          onClick={() => setOpen((v) => !v)}
          aria-label="Abrir menú"
          data-testid="navbar-mobile-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="xl:hidden bg-[hsl(var(--cream))] border-t border-[hsl(var(--border))]" data-testid="navbar-mobile-drawer">
          <div className="px-5 py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="text-base text-[hsl(var(--navy))] py-1"
              >
                {item.label}
              </a>
            ))}
            <div className="pt-3 grid grid-cols-2 gap-2">
              <a href={telLink}>
                <Button variant="outline" className="w-full rounded-full">
                  <Phone className="w-4 h-4" /> Llamar
                </Button>
              </a>
              <a href={waLink()} target="_blank" rel="noreferrer">
                <Button className="w-full rounded-full bg-[hsl(var(--soft-red))] hover:bg-[hsl(var(--soft-red))]/90 text-white">
                  WhatsApp
                </Button>
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
